export default __webpack_public_path__ + "static/media/import-manual.fc1dd640.svg";